import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)


export default new Router({
    routes: [{
        path: '',
        name: '',
        component: resolve => require(['../pages/calendar/fullCalendar'], resolve),
    }, {
        path: '/home',
        name: 'home',
        component: resolve => require(['../pages/home/home'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "首页"
            next()
        }
    }, {
        path: '/fullCalendar',
        name: 'fullCalendar',
        component: resolve => require(['../pages/calendar/fullCalendar'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "日历"
            next()
        }
    },{
        path: '/calendar',
        name: 'calendar',
        component: resolve => require(['../pages/calendar/calendar'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "排课"
            next()
        }
    }, {
        path: '/login/:type',
        name: 'login',
        component: resolve => require(['../pages/login/login'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "登录"
            next()
        }
    }, {
        path: '/personal/:sysUserId',
        name: 'personal',
        component: resolve => require(['../pages/personal/personal'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "个人中心"
            next()
        }
    }, {
        path: '/family',
        name: 'family',
        component: resolve => require(['../pages/family/family'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "家庭"
            next()
        }
    }, {
        path: '/teacher',
        name: 'teacher',
        component: resolve => require(['../pages/teacher/teacher'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "教师"
            next()
        }
    }, {
        path: '/setup',
        name: 'setup',
        component: resolve => require(['../pages/setup/setup'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "系统配置"
            next()
        }
    }, {
        path: '/project',
        name: 'project',
        component: resolve => require(['../pages/project/project'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "项目列表"
            next()
        }
    }, {
        path: '/family/detail',
        name: 'familyDetail',
        component: resolve => require(['../pages/family/familyDetail'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "家庭详情"
            next()
        }
    }, {
        // 家庭下的家长信息页面
        path: '/family/parMsg',
        name: 'parMsg',
        component: resolve => require(['../pages/family/parMsg'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "家长信息"
            next()
        }
    }, {
        // 家庭下的学生信息页面
        path: '/family/stuMsg',
        name: 'stuMsg',
        component: resolve => require(['../pages/family/stuMsg'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "学生信息"
            next()
        }
    }, {
        // 项目下的任务
        path: '/objMsg/:type/:objId/:stuName',
        name: 'objMsg',
        component: resolve => require(['../pages/project/objMsg'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "项目信息" + to.params.stuName?to.params.stuName:''
            next()
        },
        //把该路由组件收到的所有params参数，以props形式传给objMsg组件
        // props:true
        //函数式传值
        props($route){
            return {
                type:$route.query.id,
                objId:$route.query.objId,
                stuName:$route.query.stuName
            }
        }
    }, {
        path: '/task',
        name: 'task',
        component: resolve => require(['../pages/task/task'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "任务"
            next()
        }
    }, {
        path: '/feedback',
        name: 'feedback',
        component: resolve => require(['../pages/feedback/feedback'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "反馈"
            next()
        }
    },{
        path: '/feedbackDetail',
        name: 'feedDetail',
        component: resolve => require(['../pages/feedback/feedDetail'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "反馈详情"
            next()
        }
    }, {
        path: '/targetColleges',
        name: 'targetColleges',
        component: resolve => require(['../pages/targetColleges/targetColleges'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "目标院校"
            next()
        }
    }, {
        path: '/university',
        name: 'university',
        component: resolve => require(['../pages/university/university'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "院校"
            next()
        }
    }, {
        path: '/uniDetail',
        name: 'uniDetail',
        component: resolve => require(['../pages/university/uniDetail'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "院校详情"
            next()
        }
    }, {
        path: '/teClass',
        name: 'teClass',
        component: resolve => require(['../pages/teClass/teClass'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "课次"
            next()
        }
    },{
        path: '/stuClass',
        name: 'stuClass',
        component: resolve => require(['../pages/stuClass/stuClass'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "学生课次"
            next()
        }
    }, {
        path: '/outline',
        name: 'outline',
        component: resolve => require(['../pages/outline/outline'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "大纲"
            next()
        }
    }, {
        path: '/view',
        name: 'view',
        component: resolve => require(['../pages/outline/view'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "大纲-学生视野"
            next()
        }
    }, {
        path: '/learningLinks',
        name: 'learningLinks',
        component: resolve => require(['../pages/outline/learningLinks'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "大纲-学习环节"
            next()
        }
    }, {
        path: '/chartData',
        name: 'chartData',
        component: resolve => require(['../pages/chartDataSp/chartData'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "数据-站点数据"
            next()
        }
    }, {
        path: '/school',
        name: 'school',
        component: resolve => require(['../pages/schoolSP/school'], resolve),//git上面这个目录是大写
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "院校"
            next()
        }
    }, {
        path: '/banner',
        name: 'banner',
        component: resolve => require(['../pages/bannerSp/banner'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "开屏图"
            next()
        }
    }, {
        path: '/requestForm',
        name: 'requestForm',
        component: resolve => require(['../pages/requestform/requestForm'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "Request Form"
            next()
        }
    }, {
        path: '/studyPlan',
        name: 'studyPlan',
        component: resolve => require(['../pages/studyPlan/studyPlan.vue'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "Study Plan"
            next()
        }
    }, {
        path: '/report',
        name: 'report',
        component: resolve => require(['../pages/report/report.vue'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "Report"
            next()
        }
    }, {
        path: '/homework',
        name: 'homework',
        component: resolve => require(['../pages/homework/homework.vue'], resolve),
        beforeEnter: (to, from, next) => {
            document.getElementById("mainTitle").innerHTML = "Homework"
            next()
        }
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js